<template>
  <div style="width: 100%;height: 100%;background-color: white;">
    <div style="height: 100%;width: 100%;padding-top: 20px;box-sizing: border-box" v-loading="loading" element-loading-text="加载中，请耐心等待。">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <tree-data ref="tree" @checkChange="checkChange"></tree-data>
        </el-col>
        <el-col :span="20" style="height: 100%;background-color: white;overflow-y: auto">
          <div style="height: 100%;margin: 0 20px">
            <div style="height: 50px">
              <el-button v-if="$store.state.user.moduletag !== 2" type="primary" plain icon="el-icon-plus" @click="addNewOrg()">新增</el-button>
              <el-input prefix-icon="el-icon-search" placeholder="输入组织名称搜索" v-model="searchKeyword" clearable style="width: 250px"></el-input>
            </div>
            <div style="max-height: calc(100% - 100px);overflow-y: auto">
              <el-table :data="tbdata" border style="width: 100%" highlight-current-row ref="singleTable">
                <el-table-column
                  type="index"
                  label="序号"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="组织名称"
                  min-width="80">
                </el-table-column>
                <el-table-column
                  label="上级组织"
                  min-width="70">
                  <template slot-scope="scope">
                    {{getOrgpidName(scope.row)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createtime"
                  label="录入时间"
                  min-width="90">
                </el-table-column>
                <el-table-column
                  align="center"
                  v-if="$store.state.user.moduletag === 2"
                  label="机构"
                  width="110">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.entity_id > 0" type="primary" plain size="mini" @click="getUnitData(scope.row)">机构详情</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  v-if="$store.state.user.moduletag === 1"
                  label="实体"
                  width="110">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.entity_id === 0" type="primary" plain size="mini" @click="getOpenUnit(scope.row)">添加实体</el-button>
                    <el-button v-else type="success" plain size="mini" @click="getOpenUnit(scope.row)">实体详情</el-button>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="130"  class-name="small-padding fixed-width">
                  <template slot-scope="scope">
                    <i v-if="$store.state.user.moduletag !== 2" title="设置" style="cursor: pointer; font-size: 18px;color: blue" class="el-icon-s-tools" @click="openList(scope.row)"></i>
                    <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editOrg(scope.row)"></i>
                    <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delOrg(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="text-align: center;margin-top: 10px;height: 40px;">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells">
              </el-pagination>
            </div>
          </div>
        </el-col>
    </el-row>
    </div>
    <!--created-->
    <el-dialog :visible.sync="addShow" v-if="addShow" width="500px"
      :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>新增组织</span></div>
        <div class="line-title"></div>
      </div>
      <org-add :orgAddRow="addRow" v-model="addShow"></org-add>
    </el-dialog>
    <!--update-->
    <el-dialog :visible.sync="editShow" v-if="editShow" width="500px"
      :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>更新组织</span></div>
        <div class="line-title"></div>
      </div>
      <org-edit :orgEditRow="editRow" v-model="editShow"></org-edit>
    </el-dialog>
    <!--设置-->
    <el-dialog :visible.sync="listShow" v-if="listShow" width="650px"
      :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{listTitle}}</span> </div>
        <div class="line-title"></div>
      </div>
      <org-list-set :listObj="listObj" v-model="listShow"></org-list-set>
    </el-dialog>
    <!--新增实体-->
    <el-dialog :visible.sync="addUnitShow" v-if="addUnitShow" width="1200px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div>{{unitObj.orgRow.name}} - <span>{{unitTitle}}</span></div>
        <div class="line-title"></div>
      </div>
      <div style="height: 550px;overflow-y: auto">
        <organization-info :unitObj="unitObj" @updateTable="updateTable"></organization-info>
      </div>
<!--      <add-edit-unit v-model="addUnitShow" :unitObj="unitObj" @updateTable="updateTable"></add-edit-unit>-->
    </el-dialog>
  </div>
</template>

<script>
import treeData from '../treeData/treeData.vue'
import orgAdd from './childComponents/orgAdd'
import orgEdit from './childComponents/orgEdit'
import orgListSet from './orgComponents/orgListSet'
import addEditUnit from './orgComponents/addEditUnit'
import organizationInfo from '../oldPersonHome/organizationInfo'
import {deleteorg} from '../../api/organizer'
export default {
  name: 'organization',
  components: {treeData, orgAdd, orgEdit, orgListSet, addEditUnit, organizationInfo},
  data () {
    return {
      filterText: '',
      orgData: [],
      // 左边
      searchKeyword: '',
      treeData: [],
      isFirst: [],
      // 右边
      tableData: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addShow: false,
      addRow: {
        orgTree: [],
        orgArr: []
      },
      editShow: false,
      editRow: {
        orgTree: [],
        row: {}
      },
      listShow: false,
      listTitle: '',
      listObj: {
        orgRow: ''
      },
      addUnitShow: false,
      unitTitle: '新增实体',
      unitObj: {
        treeData: [],
        orgRow: '',
        entity: '',
        isAdd: true
      }
    }
  },
  created () {
    this.golobleObject.updateTableOrg = this.getOrgDatalist
  },
  mounted () {
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    getOrgDatalist () {
      this.$refs.tree.getOrgData()
    },
    checkChange (obj) {
      if (obj.type === 'check') {
        this.currentPage = 1
        this.isFirst = obj.orgids
        this.getEndTable()
      } else if (obj.type === 'data') {
        this.orgData = obj.orgData
        this.addRow.orgArr = this.clone(obj.orgData)
        this.addRow.orgTree = obj.treeData
        this.editRow.orgTree = obj.treeData
        this.unitObj.treeData = obj.treeData
        this.getEndTable()
      }
    },
    getEndTable () {
      this.tableData = []
      if (this.isFirst.length === 0) {
        this.tableData = this.orgData
      } else {
        for (let i = 0; i < this.orgData.length; i++) {
          if (this.isFirst.indexOf(this.orgData[i].id) > -1) {
            this.tableData.push(this.orgData[i])
          }
        }
      }
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      const data = this.tableData
      const vm = this
      const search = data.filter((val) => {
        if (val.name.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      return arr
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    // 表格
    getOrgpidName (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgpid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    },
    // 新建组织
    addNewOrg () {
      this.addShow = true
    },
    // 编辑组织
    editOrg (row) {
      // console.log(row)
      this.editRow.row = row
      this.editShow = true
    },
    // 删除组织
    delOrg (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该群组【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          orgids: [row.id]
        }
        deleteorg(data).then(() => {
          this.getOrgDatalist()
          this.$notify({
            title: '成功',
            message: '成功删除组织',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除组织失败'
          })
        })
      }).catch(() => {})
    },
    // 设置
    openList (row) {
      this.listTitle = '【' + row.name + '】' + '设置'
      this.listObj.orgRow = row
      this.listShow = true
    },
    // 新增实体
    addUnit () {
      this.unitTitle = '新增实体'
      this.unitObj.isAdd = true
      this.addUnitShow = true
    },
    getUnitData (row) {
      this.$router.push({path: '/organizationInfo'})
      let obj = {
        type: 'path',
        path: '/organizationInfo',
        monitor: false
      }
      this.golobleObject.getChangeLevel2(obj) // home.vue
    },
    updateTable () {
      this.getOrgDatalist()
      this.addUnitShow = false
    },
    getOpenUnit (row) {
      this.unitTitle = row.entity_id === 0 ? '新建实体' : '实体详情'
      this.unitObj.orgRow = row
      this.addUnitShow = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/organization.vue